import { images } from "../../assets/images";


export const presentDeliverTool = {
  id: "slide-deck-generator",
  title: "Slide Deck Generator",
  description:
  "Convert any topic or document into a 10-slide presentation with speaker notes and visuals.",
  ctaLabel: "Create Presentation",
  iconSrc: images.presentIcon,
  href: "#slide-deck-generator",
  theme: "presentation"
};